let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1R71m")).then(() => parcelRequire('2S3hF'));